module.exports = __webpack_public_path__ + "426f024e0e17d7e0d408eec6f1411635.png";